import React from "react";
import PropTypes from "prop-types";
import Mustache from "mustache";
import { useProcessedLinks } from "components/hooks/useProcessedLinks";

export function MessageWithLinks({ message }) {
  const apiLinks = useProcessedLinks();
  const rendered = Mustache.render(message.description, apiLinks);
  return <div dangerouslySetInnerHTML={{ __html: rendered }} />;
}

MessageWithLinks.propTypes = {
  message: PropTypes.shape({
    description: PropTypes.string,
  }),
};
